module.exports = __webpack_public_path__ + "static/media/main_logo.2f7bac3d.svg";